import { datadogRum } from '@datadog/browser-rum'
import type { RequiredGap } from '@seen/core/observation-logic/noteCapture'

// Where a note was signed or submitted from, for telling apart the surfaces
// a template's required questions get in the way on.
export type RequiredAnswersSurface =
  | 'visit-note'
  | 'desk-note'
  | 'timeline-note'
  | 'comment'
  | 'assessment'
  | 'task'

function fields(surface: RequiredAnswersSurface, gaps: readonly RequiredGap[]) {
  return {
    surface,
    count: gaps.length,
    labels: gaps.map((gap) => gap.label),
  }
}

// A sign or submit stopped for required questions left unanswered.
export function reportRequiredAnswersBlocked(
  surface: RequiredAnswersSurface,
  gaps: readonly RequiredGap[]
): void {
  datadogRum.addAction('note.required_answers.blocked', fields(surface, gaps))
}

// Signed or submitted anyway: the template asked for something that did
// not apply, which is what these are collected to find.
export function reportRequiredAnswersOverridden(
  surface: RequiredAnswersSurface,
  gaps: readonly RequiredGap[]
): void {
  datadogRum.addAction(
    'note.required_answers.overridden',
    fields(surface, gaps)
  )
}
